var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45188 11.9328C7.17446 9.31137 8.30173 6.50558 8.20476 4.37901C8.15477 3.28261 7.78189 2.3805 7.15592 1.75582C6.53391 1.13511 5.62978 0.755715 4.44508 0.755715C3.26072 0.755715 2.3771 1.13469 1.7785 1.75144C1.17496 2.37328 0.825533 3.27402 0.792109 4.37353C0.727321 6.5048 1.85858 9.31196 4.45188 11.9328ZM1.20012 1.23707C1.96845 0.44544 3.07308 0 4.44508 0C5.81672 0 6.93635 0.445019 7.72565 1.23269C8.51099 2.01639 8.93697 3.10661 8.99348 4.34606C9.10627 6.81956 7.7578 9.94134 4.71882 12.7415L4.43831 13L4.16447 12.7351C1.2713 9.93592 -0.0720185 6.8184 0.00297125 4.35155C0.0405545 3.11521 0.436724 2.02361 1.20012 1.23707Z",
    fill: "#525559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50007 5.92891C5.2849 5.92891 5.92112 5.27412 5.92112 4.46641C5.92112 3.65869 5.2849 3.00391 4.50007 3.00391C3.71525 3.00391 3.07902 3.65869 3.07902 4.46641C3.07902 5.27412 3.71525 5.92891 4.50007 5.92891ZM4.50007 6.74141C5.72091 6.74141 6.71059 5.72285 6.71059 4.46641C6.71059 3.20996 5.72091 2.19141 4.50007 2.19141C3.27924 2.19141 2.28955 3.20996 2.28955 4.46641C2.28955 5.72285 3.27924 6.74141 4.50007 6.74141Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.74f90b2c59722ebe01864aec12bfc66d.svg";
export { ForwardRef as ReactComponent };